
export default {
  props: {
    checked: {
      default: false,
    },
  },
};
